import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetopanvelcab() {



    const cardData = {

keyword: "Pune to Panvel Cab",

headingDescription:
    "Rising Cab Service offers safe, reliable, and comfortable Pune to Panvel Cab services for families, business travelers, tourists, and daily commuters. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles driven by experienced chauffeurs for a smooth highway journey. Our service includes one-way and round-trip options, doorstep pickup from Pune, 24/7 booking support, and transparent pricing. Whether you are traveling for work, railway connectivity, or onward travel to Navi Mumbai and Mumbai, Rising Cab Service ensures a hassle-free and comfortable journey to Panvel.",

topPlaces: [
    {
        title: "Karnala Bird Sanctuary",
        description:
            "Karnala Bird Sanctuary is a popular eco-tourism spot near Panvel known for its rich birdlife, trekking trails, and the historic Karnala Fort located within the sanctuary."
    },
    {
        title: "Karnala Fort",
        description:
            "Karnala Fort is a hill fort offering scenic trekking routes and panoramic views of the Western Ghats. It is a favorite destination for adventure lovers near Panvel."
    },
    {
        title: "Panvel Railway Junction",
        description:
            "Panvel Railway Junction is one of the busiest railway stations in Navi Mumbai, serving as a key connectivity point for Konkan routes, Mumbai, and long-distance travel."
    },
    {
        title: "Kalavantin Durg",
        description:
            "Kalavantin Durg is a famous and challenging trekking fort near Panvel known for its steep steps and breathtaking views of the Sahyadri mountains."
    },
    {
        title: "Prabalgad Fort",
        description:
            "Prabalgad Fort is a historic fort located between Matheran and Panvel, offering scenic trekking trails and stunning valley views."
    },
    {
        title: "Matheran (Nearby Hill Station)",
        description:
            "Matheran is a popular hill station near Panvel known for its toy train, vehicle-free environment, viewpoints, and lush green landscapes."
    },
    {
        title: "Utsav Chowk Kharghar",
        description:
            "Utsav Chowk in Kharghar is a beautifully designed monument symbolizing Indian culture and architecture, located near Panvel in Navi Mumbai."
    },
    {
        title: "Kharghar Hills",
        description:
            "Kharghar Hills are part of the Pandavkada region offering trekking routes, waterfalls during monsoon, and scenic views of Navi Mumbai."
    },
    {
        title: "Pandavkada Waterfalls",
        description:
            "Pandavkada Waterfalls is a seasonal waterfall near Panvel famous for its natural beauty during monsoon and is a popular picnic destination."
    },
    {
        title: "Belapur CBD",
        description:
            "CBD Belapur is a major commercial and administrative hub in Navi Mumbai known for corporate offices, government buildings, and urban infrastructure."
    }
],



services: [
    {
        name: "Pune to Panvel Cab",
        description:
            "Rising Cab Service offers Pune to Panvel Cab for safe, fast, and comfortable intercity travel via Mumbai–Pune expressway. This service is ideal for business travel, family visits, airport transfers, and weekend trips. We provide well-maintained AC vehicles including hatchbacks, sedans, SUVs, Innova, and Innova Crysta with experienced drivers trained for expressway and Navi Mumbai routes. Customers can choose one-way or round-trip options with door-to-door pickup and drop service. With transparent pricing, 24x7 availability, and reliable service, we ensure a smooth and stress-free journey between Pune and Panvel."
    },
    {
        name: "Pune to Panvel Taxi",
        description:
            "Book Pune to Panvel Taxi with Rising Cab Service for affordable, safe, and comfortable travel. Our taxis are suitable for solo passengers, families, and corporate travelers who need reliable intercity transportation with clean vehicles and professional chauffeurs for expressway travel."
    },
    {
        name: "Cab from Pune to Panvel",
        description:
            "Rising Cab Service provides Cab from Pune to Panvel with flexible pickup options, AC vehicles, and experienced drivers ensuring smooth highway and expressway travel with timely arrival and comfort."
    },
    {
        name: "Taxi from Pune to Panvel",
        description:
            "Our Taxi from Pune to Panvel service ensures safe, punctual, and comfortable travel with well-trained drivers, clean vehicles, and budget-friendly pricing for all types of passengers."
    },
    {
        name: "Pune to Panvel Cab Service",
        description:
            "Rising Cab Service offers Pune to Panvel Cab Service with easy booking, reliable transportation, and professional drivers ensuring a hassle-free travel experience for short and long-distance trips."
    },
    {
        name: "Pune to Panvel Taxi Fare",
        description:
            "Get transparent Pune to Panvel Taxi Fare with no hidden charges. We offer competitive pricing suitable for one-way, round-trip, and airport transfer travel between Pune and Panvel."
    },
    {
        name: "Pune to Panvel One Way Cab",
        description:
            "Book Pune to Panvel One Way Cab for cost-effective single-trip travel with comfortable vehicles and experienced expressway-trained drivers."
    },
    {
        name: "Pune to Panvel Round Trip Taxi",
        description:
            "Rising Cab Service provides Pune to Panvel Round Trip Taxi with flexible return timing, waiting options, and customized travel plans for families and corporate travelers."
    },
    {
        name: "Pune to Panvel Cab Booking",
        description:
            "Our Pune to Panvel Cab Booking service offers instant confirmation, multiple vehicle options, and 24x7 support for quick and easy travel planning."
    },
    {
        name: "Cheap Pune to Panvel Cab",
        description:
            "Rising Cab Service offers Cheap Pune to Panvel Cab with budget-friendly fares while ensuring safety, comfort, and reliable expressway travel experience."
    },
    {
        name: "Best Pune to Panvel Taxi",
        description:
            "Choose the Best Pune to Panvel Taxi with Rising Cab Service for premium comfort, punctual service, and experienced drivers ensuring smooth highway travel."
    },
    {
        name: "Sedan Pune to Panvel Cab",
        description:
            "Our Sedan Pune to Panvel Cab is ideal for individuals and small families looking for affordable and comfortable intercity travel."
    },
    {
        name: "SUV Pune to Panvel Taxi",
        description:
            "Book SUV Pune to Panvel Taxi for spacious seating, extra luggage capacity, and comfortable group travel on long expressway routes."
    },
    {
        name: "Innova Pune to Panvel Cab",
        description:
            "Rising Cab Service offers Innova Pune to Panvel Cab for family and group travel with premium comfort, smooth rides, and reliable long-distance service."
    },
    {
        name: "Fast Route Cab Pune Panvel",
        description:
            "Our Fast Route Cab Pune Panvel service ensures quick, safe, and efficient travel using optimized expressway and highway routes for time-saving journeys with experienced drivers."
    },
    {
        name: "Panvel to Pune Cab",
        description:
            "Rising Cab Service also provides Panvel to Pune Cab with reliable return trip options, comfortable vehicles, and professional drivers for smooth intercity travel."
    },
    {
        name: "Pune to Navi Mumbai Cab",
        description:
            "Book Pune to Navi Mumbai Cab for safe and convenient travel to business hubs, residential areas, and industrial zones with professional chauffeurs."
    },
    {
        name: "Pune to Mira Road Taxi",
        description:
            "Our Pune to Mira Road Taxi service ensures comfortable long-distance travel with experienced drivers and well-maintained AC vehicles."
    },
    {
        name: "Pune to Borivali Cab",
        description:
            "Rising Cab Service offers Pune to Borivali Cab for smooth Mumbai travel with reliable drivers and expressway route optimization."
    },
    {
        name: "Pune to Andheri Taxi",
        description:
            "Book Pune to Andheri Taxi for safe, punctual, and comfortable travel to one of Mumbai’s busiest commercial and residential areas."
    },
    {
        name: "Pune to Vasai Cab",
        description:
            "Our Pune to Vasai Cab service ensures affordable and comfortable travel with professional drivers and flexible booking options."
    },
    {
        name: "Pune to Bhiwandi Taxi",
        description:
            "Rising Cab Service provides Pune to Bhiwandi Taxi for business and industrial travel with safe and efficient highway routes."
    },
    {
        name: "Pune to Palghar Cab",
        description:
            "Book Pune to Palghar Cab for long-distance travel with comfortable seating, reliable drivers, and budget-friendly fares."
    },
    {
        name: "Pune to Mumbai Airport Taxi",
        description:
            "Our Pune to Mumbai Airport Taxi service ensures timely airport transfers with 24x7 availability, flight tracking, and stress-free travel."
    },
    {
        name: "Pune to Kharghar Taxi",
        description:
            "Rising Cab Service offers Pune to Kharghar Taxi for smooth travel to Navi Mumbai residential and business hubs."
    },
    {
        name: "Pune to Kamothe Cab",
        description:
            "Book Pune to Kamothe Cab for safe and affordable travel with experienced drivers and comfortable vehicles."
    }
],
tableData: [
    ["Pune to Panvel Cab", "Pune to Panvel Taxi"],
    ["Cab from Pune to Panvel", "Taxi from Pune to Panvel"],
    ["Pune to Panvel One Way Cab", "Pune to Panvel Round Trip Taxi"],
    ["Pune to Panvel Cab Service", "Pune to Panvel Taxi Fare"],
    ["Cheap Pune to Panvel Cab", "Best Pune to Panvel Taxi"],
    ["Sedan Pune to Panvel Cab", "SUV Pune to Panvel Taxi"],
    ["Innova Pune to Panvel Cab", "Fast Route Cab Pune Panvel"],
    ["Panvel to Pune Cab", "Cab from Panvel to Pune"],
    ["Pune to Navi Mumbai Cab", "Pune to Mira Road Taxi"],
    ["Pune to Borivali Cab", "Pune to Andheri Taxi"]
],




whychoose: [
    {
        WhyChooseheading: "Reliable Pune to Panvel Cab Service",
        WhyChoosedescription: "Rising Cab Service provides dependable Pune to Panvel cab transportation for business travelers, families, tourists, students, and daily commuters looking for a comfortable journey."
    },
    {
        WhyChooseheading: "Convenient Travel to Navi Mumbai Region",
        WhyChoosedescription: "Panvel serves as a major gateway to Navi Mumbai, Mumbai, JNPT Port, and upcoming infrastructure hubs, making it a frequently traveled destination."
    },
    {
        WhyChooseheading: "Suitable for Airport, Business, and Personal Travel",
        WhyChoosedescription: "Whether traveling for corporate meetings, airport transfers, family visits, educational purposes, or vacations, we provide hassle-free transportation."
    },
    {
        WhyChooseheading: "Comfortable Fleet for Every Requirement",
        WhyChoosedescription: "Customers can choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and luxury vehicles based on their travel needs."
    },
    {
        WhyChooseheading: "Flexible One-Way and Return Journey Options",
        WhyChoosedescription: "We offer one-way cab services, same-day return trips, weekend travel plans, and customized transportation packages."
    },
    {
        WhyChooseheading: "Doorstep Pickup Across Pune & PCMC",
        WhyChoosedescription: "Pickup facilities are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and nearby locations."
    },
    {
        WhyChooseheading: "Professional Drivers for Expressway Travel",
        WhyChoosedescription: "Our experienced drivers are familiar with the Mumbai-Pune Expressway and ensure a safe, smooth, and comfortable travel experience."
    },
    {
        WhyChooseheading: "Ideal for Solo Travelers and Groups",
        WhyChoosedescription: "From individual passengers to family groups and corporate teams, we provide suitable vehicle options for every journey."
    }
]
};

const faqData = [
    {
        question: "Why is Panvel a popular destination from Pune?",
        answer: "Panvel is an important transit hub connecting Navi Mumbai, Mumbai, JNPT Port, industrial zones, and major transportation networks."
    },
    {
        question: "Can customers book a one-way cab from Pune to Panvel?",
        answer: "Yes, one-way taxi services are available along with round-trip and customized travel options."
    },
    {
        question: "Which vehicle category is commonly selected for Pune to Panvel travel?",
        answer: "Sedan cars, Ertiga, and Innova Crysta are frequently chosen for their comfort and convenience."
    },
    {
        question: "Are same-day return cab packages available?",
        answer: "Yes, travelers can choose same-day return journeys based on their schedule and travel requirements."
    },
    {
        question: "Do business professionals use Pune to Panvel cab services?",
        answer: "Yes, many professionals travel to Panvel for meetings, industrial visits, logistics operations, and corporate activities."
    },
    {
        question: "Can families hire larger vehicles for Panvel trips?",
        answer: "Yes, Tempo Travellers and spacious vehicles are available for families, groups, and special occasions."
    },
    {
        question: "Is airport connectivity available through this service?",
        answer: "Yes, customers can travel to Panvel while connecting to Mumbai Airport, Navi Mumbai Airport region, and nearby locations."
    },
    {
        question: "Can travelers include multiple destinations during the trip?",
        answer: "Yes, customized itineraries can include Navi Mumbai, Mumbai, Lonavala, Alibaug, or other nearby destinations."
    },
    {
        question: "Are pickups available from Pune Airport and Railway Station?",
        answer: "Yes, pickups can be arranged from Pune Airport, Railway Station, hotels, offices, and residential addresses."
    },
    {
        question: "How can I book a Pune to Panvel Cab?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Nitin Khare",
        feedback:
            "My journey to Panvel for a business assignment was extremely comfortable. The cab arrived on time, and the entire trip was completed smoothly without any inconvenience.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Pooja Salunkhe",
        feedback:
            "We traveled to Panvel with family for a special occasion and were impressed by the professionalism of Rising Cab Service. The vehicle was spacious and the ride was very relaxing.",
        rating: 5
    }
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Panvel Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-panvel-cab.jpg",
"description": "Book Pune to Panvel Cab Service with Rising Cab Service for safe, fast, and comfortable travel via expressway. Enjoy reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars at affordable prices.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-panvel-cab"
}
};







    return (
        <div>

<Helmet>
  <title>Pune to Panvel Cab Service | Fast & Affordable Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Panvel Cab Service for fast and safe travel via expressway. Get affordable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars."
/>

<meta
 name="keywords"
 content="pune to panvel cab, pune to panvel taxi, cab from pune to panvel, taxi from pune to panvel, pune to panvel cab service, pune to panvel taxi fare, pune to panvel one way cab, pune to panvel round trip taxi, pune to panvel cab booking, cheap pune to panvel cab, best pune to panvel taxi, sedan pune to panvel cab, suv pune to panvel taxi, innova pune to panvel cab, fast route cab pune panvel, panvel to pune cab, Pune to panvel cab, cab from panvel to pune, Panvel to pune cab charges, pune to panvel cab price, Pune to panvel taxi, Pune to Navi Mumbai cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/43.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetopanvelcab;